import dynamic from 'next/dynamic';

const CarrouselFeatured = dynamic(() => import('./CarrouselFeatured'));

export default CarrouselFeatured;
